module.exports = __webpack_public_path__ + "img/MaidenofWaxInkBlack.c9c503e8.png";